import React from 'react';
import { VpModal, VpModalDialog, VpModalHeader, VpModalBody, VpModalFooter, VpModalCloseButton, VpButton } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';

import styles from './ConfirmationModal.module.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmationModal = ({ isOpen, onClose, onConfirm }: ConfirmationModalProps) => {
  const { t } = useTranslation();
  return (
    <VpModal open={isOpen} onClose={onClose} onOpen={() => {}} closeOnClickOutside>
      <VpModalDialog aria-label={t('confirm.modal.title')}>
        <VpModalHeader>
          <h2>{t('confirm.modal.title')}</h2>
          <VpModalCloseButton aria-label={t('confirm.modal.close')} onClick={onClose} />
        </VpModalHeader>

        <VpModalBody className={styles.confirmationModalBody}>
          <span className="vp-body-s">{t('confirm.modal.description')}</span>
        </VpModalBody>

        <VpModalFooter className={styles.confirmationModalFooter}>
          <VpButton variant="secondary" onClick={onClose}>
            {t('cancel')}
          </VpButton>
          <VpButton onClick={onConfirm}>{t('quit')}</VpButton>
        </VpModalFooter>
      </VpModalDialog>
    </VpModal>
  );
};
